import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './AddWarehouseModal.module.scss';
import Select from '../../common/Select';
import ModalWindow from '../../common/Modal';
import ConnectShopifyForm from '../../forms/ConnectShopifyForm';
import ConnectShipBobForm from '../../forms/ConnectShipBobForm';
import ConnectAmazonMcfForm from '../../forms/ConnectAmazonMcfForm';
import { ConnectNetSuiteForm } from '../../forms/ConnectNetSuiteForm';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { netSuiteSupplierOnboarding, salesforceSupplierOnboarding } from '../../../constants/featureFlag';
import { ConnectSalesforceForm } from '../../forms/ConnectSalesforceForm';

function AddWarehouseModal(props) {
  const { open, onClose, onContinue } = props;
  const netSuiteEnabled = useFeatureFlag(netSuiteSupplierOnboarding, false);
  const salesforceEnabled = useFeatureFlag(salesforceSupplierOnboarding, false);
  const [warehouseProvider, setWarehouseProvider] = useState('');

  const warehouseProviders = [
    { label: 'Choose a Provider', value: '' },
    { label: 'Shopify', value: 'shopify' },
    { label: 'ShipBob', value: 'shipbob' },
    { label: 'Amazon MCF', value: 'amazon_mcf' },
  ];

  if (netSuiteEnabled) {
    warehouseProviders.push({ label: 'NetSuite', value: 'net_suite' });
  }
  if (salesforceEnabled) {
    warehouseProviders.push({ label: 'Salesforce', value: 'salesforce_commerce_cloud' });
  }

  const handleContinue = (...args) => {
    onContinue(warehouseProvider, ...args);
  };

  return (
    <ModalWindow size={warehouseProvider === 'salesforce_commerce_cloud' ? 'medium' : ''} open={open} onClose={onClose}>
      <div className={styles.body}>
        <p>Please select your warehouse provider:</p>
        <Select
          className={styles.baa}
          value={warehouseProvider}
          options={warehouseProviders}
          onChange={setWarehouseProvider}
        />
        <hr />
        {warehouseProvider === 'shopify' && <ConnectShopifyForm submit={handleContinue} />}
        {warehouseProvider === 'shipbob' && <ConnectShipBobForm submit={handleContinue} />}
        {warehouseProvider === 'amazon_mcf' && <ConnectAmazonMcfForm submit={handleContinue} />}
        {netSuiteEnabled && warehouseProvider === 'net_suite' && <ConnectNetSuiteForm />}
        {warehouseProvider === 'salesforce_commerce_cloud' && salesforceEnabled && <ConnectSalesforceForm />}
      </div>
    </ModalWindow>
  );
}

export default AddWarehouseModal;

AddWarehouseModal.defaultProps = {
  open: false,
};

AddWarehouseModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};
